import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { searchEntityInSite } from '../../../SHARED/actions/searchresults.actions';
import MovieListItem from "../../../SHARED/components/movielistitem/movielistitem.component";
import ArticleItem from "../../../SHARED/components/articles/articlesitem.component";
import AllnewsContainer from "../../../FO/components/news/containers/allnewscontainer.component";
import MovieTheaterDetails from "../../../FO/components/movietheaters/containers/movietheatersdetails.component";
import { Link } from 'react-router-dom';
import Parser from 'html-react-parser';
import { pageViewEvent, slugify } from '../../helpers/general.helper';
import { API_URL } from '../../config/apiEndpoints';
import Moment from "react-moment";
import { Helmet } from 'react-helmet';

class SearchResults extends Component {

    componentWillMount() {
        window.scrollTo(0, 0);
        this.searchedTerm = '';
        if (this.props.match.params.term) {
            this.searchedTerm = this.props.match.params.term;
            let payload = {};
            payload.searchedText = this.searchedTerm;
            this.props.searchEntityInSite(payload);
        }
    }

    componentDidMount() {
        pageViewEvent(`Rezultatele căutării după "${this.searchedTerm}"`, window.location.href)
    }

    showMovies(movie) {
        return <MovieListItem key={movie.filmId} card={movie} component="searchresultsmovies" />
    }

    showArticles(article) {
        return <ArticleItem key={article.article_id} article={article} component="searchresultsarticles" />
    }

    showCinema(movieTheater) {
        return <MovieTheaterDetails key={movieTheater.cinema_id} id={movieTheater.cinema_id}
            name={movieTheater.cinema_name}
            halls={movieTheater.cinema_nr_of_rooms}
            phone={movieTheater.cinema_telephone}
            email={movieTheater.cinema_email}
            site={movieTheater.cinema_website}
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis imperdiet odio commodo, facilisis sapien in, venenatis augue. Nullam pharetra sit amet diam dictum tempor. Nulla sodales varius diam sit amet pellentesque. Nunc id eleifend nunc, sed bibendum nisl. Proin quis volutpat quam. Duis vehicula nibh magna, sollicitudin venenatis nunc pharetra nec. Mauris malesuada ex tellus, at tempor mi iaculis ac. Suspendisse gravida scelerisque ullamcorper."
            isSearchPage={true} />
    }

    showFestival(festival) {

        return <div key={festival.festival_id}>
            <div className="festival-title">
                <Link to={`/festival/${festival.festival_id}/${slugify(festival.festival_title)}`} className="article-link">
                    {festival.festival_title}
                </Link>
            </div>
            <div className="festival-location">{festival.festival_location}</div>
            <div className="festival-description">{Parser(festival.festival_description)}</div>
            <div className="col-12 end-line marginTop"></div>
        </div>
    }

    showEveniment(event) {
        return <div className="row no-gutters event-item" key={event.event_id}>
            <div className="col-2">
                <img src={API_URL + event.event_image} alt="Cinemap" />
            </div>
            <div className="col">
                <div className="event-title">
                    <Link to={`/festival/${event.event_id}/${slugify(event.event_title)}`} className="article-link">
                        {event.event_title}
                    </Link>
                </div>
                <div className="event-description-general">
                    <div className="event-date">Data:&nbsp;
                        <Moment format="DD MMMM YYYY" locale="ro" unix>
                            {event.event_date}
                        </Moment></div>
                    <div className="event-location">Oras:&nbsp;{event.event_location_locality}</div>
                    <div className="event-location">Adresa:&nbsp;{event.event_location_address}</div>
                    <div className="event-location">Locatie:&nbsp;{event.event_location_name}</div>
                    <div className="event-description">Descriere:&nbsp; {Parser(event.event_description)}</div>
                </div>
            </div>
            <div className="col-12 end-line marginTop"></div>
        </div>
    }

    showCelebrities(celebrity) {
        return <div className="row no-gutters celebrity-item" key={celebrity.celebrity_id}>
            <div className="col-2">
                <img src={API_URL + celebrity.celebrity_image} alt="Cinemap" />
            </div>
            <div className="col">
                <div className="celebrity-title">
                    {celebrity.celebrity_name}
                </div>
                <div className="celebrity-description-general">
                    <div className="celebrity-description">Biografie:&nbsp; {Parser(celebrity.celebrity_biography)}</div>
                </div>
            </div>
            <div className="col-12 end-line marginTop"></div>
        </div>
    }

    render() {
        return (
            <Fragment>
                <div className="search-result-container">
                    {this.props.loading !== 0 ? <Spinner /> : ''}
                    <Helmet>
                        <title>Rezultatele căutării după "{this.searchedTerm}"</title>
                        <meta name="description" content={`Rezultatele căutării după "${this.searchedTerm}". Informații, filme, articole.`}/>
                        <link rel="canonical" href={window.location.href}/>
                    </Helmet>
                    <div className="search-title">Rezultatele căutării după "{this.searchedTerm}"</div>
                    <div className="row">
                        <div className="col-12 col-sm-8">

                            <div className="row no-gutters">
                                <div className="col search-movie-container">
                                    <span className="entity-name">Filme</span>
                                    <div className="row no-gutters movie-results movie-results-search">
                                        {this.props.movies && this.props.movies.map(this.showMovies, this)}
                                        {this.props.movies && this.props.movies.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row no-gutters">
                                <div className="col search-article-container">
                                    <span className="entity-name">Articole</span>
                                    <div className="row no-gutters">
                                        {this.props.articles && this.props.articles.map(this.showArticles, this)}
                                        {this.props.articles && this.props.articles.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row no-gutters">
                                <div className="col search-movie-theaters-container">
                                    <span className="entity-name">Cinematografe</span>
                                    <div className="row no-gutters">
                                        {this.props.movieTheaters && this.props.movieTheaters.map(this.showCinema, this)}
                                        {this.props.movieTheaters && this.props.movieTheaters.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row no-gutters">
                                <div className="col search-festival-container">
                                    <span className="entity-name">Festivaluri</span>
                                    <div className="row no-gutters">
                                        {this.props.festivals && this.props.festivals.map(this.showFestival, this)}
                                        {this.props.festivals && this.props.festivals.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row no-gutters">
                                <div className="col search-event-container">
                                    <span className="entity-name">Evenimente</span>
                                    <div className="row no-gutters">
                                        {this.props.events && this.props.events.map(this.showEveniment, this)}
                                        {this.props.events && this.props.events.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row no-gutters">
                                <div className="col search-celebrities-container">
                                    <span className="entity-name">Celebritati</span>
                                    <div className="row no-gutters">
                                        {this.props.celebrities && this.props.celebrities.map(this.showCelebrities, this)}
                                        {this.props.celebrities && this.props.celebrities.length === 0 && <div className="schedule-no-results">Nu s-a găsit nici un rezultat...</div>}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col"></div>
                        <div className="col-12 col-sm-3 last-news-container-search"><AllnewsContainer /></div>
                    </div>
                </div>
            </Fragment >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    movies: state.searchResults.movies,
    articles: state.searchResults.articles,
    celebrities: state.searchResults.celebrities,
    movieTheaters: state.searchResults.movieTheaters,
    events: state.searchResults.events,
    festivals: state.searchResults.festivals
});

export default connect(mapStateToProps, { searchEntityInSite })(SearchResults);





// WEBPACK FOOTER //
// ./src/SHARED/components/searchresults/searchresults.component.js